<template>
  <div class="questionnaire">
    <div class="top-row">
      <!-- <el-input
        class="search-input"
        v-model="searchForm.query"
        size="small"
        placeholder="题目名称"
        ><el-button slot="append" size="small" icon="el-icon-search"></el-button
      ></el-input> -->
      <el-radio-group v-model="postId" size="medium">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button
          v-for="item in postList"
          :key="item.postId"
          :label="item.postId"
          >{{ item.name }}</el-radio-button
        >
      </el-radio-group>
      <div class="btns">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-refresh"
          @click="handleReset"
          >重置为系统默认</el-button
        >
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="handleDownload"
          >模板下载</el-button
        >
        <el-upload
          action="#"
          accept=".xls,.xlsx"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleImport"
          style="display: inline-block; margin: 0 10px"
        >
          <el-button type="primary" size="small" icon="el-icon-upload2"
            >导入</el-button
          >
        </el-upload> -->
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="showDialog = true"
          >新增</el-button
        >
        <el-button
          v-show="selectedIds.length != 0"
          type="danger"
          size="medium"
          icon="el-icon-delete"
          @click="handleDel(selectedIds)"
          >批量删除</el-button
        >
      </div>
    </div>

    <el-table
      :data="fList"
      stripe
      style="width: 100%"
      class="question-list"
      ref="table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="question" label="题目名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="post"
        label="匹配岗位"
        :formatter="formatter"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleEdit(scope.row.questionId)"
            >修改</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="handleDel(scope.row.questionId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="form.questionId ? '修改题目' : '新增题目'"
      :visible.sync="showDialog"
      width="30%"
      center
    >
      <el-form size="small" label-width="70px">
        <el-form-item label="题目" prop="question">
          <el-input v-model="form.question" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="匹配岗位" prop="postId">
          <el-select
            v-model="form.postId"
            size="small"
            placeholder="请选择岗位"
            style="width: 100%"
          >
            <el-option
              v-for="item in postList"
              :key="item.postId"
              :label="item.name"
              :value="item.postId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postList } from "@/api/post.js";
import {
  addQuestion,
  editQuestion,
  questionList,
  questionInfo,
  delQuestion,
  resetList,
} from "@/api/projectPractice/questionnaire.js";
import merge from "webpack-merge";
export default {
  data() {
    return {
      postId: null,
      postList: [],
      // searchForm: {
      //   query: "",
      // },
      showDialog: false,
      form: {},
      list: [],
      selectedIds: [],
    };
  },
  created() {
    this.getPostList();
    this.getList();
    if (!JSON.parse(this.$route.query.isInit)) {
      this.setFn();
      this.$router.replace({
        query: merge(this.$route.query, { isInit: "true" }),
      });
    }
  },
  computed: {
    fList() {
      return this.postId
        ? this.list.filter((item) => {
            return this.postId == item.postId;
          })
        : this.list;
    },
  },
  watch: {
    showDialog(val) {
      if (!val) this.form = this.$options.data().form;
    },
  },
  methods: {
    // 题目列表
    getList() {
      this.$loading.show();
      questionList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatter(row) {
      let obj = this.postList.find((item) => {
        return item.postId == row.postId;
      });
      return obj && obj.name;
    },
    // 岗位列表
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增题目
    handleAdd() {
      this.form.classId = this.$route.query.id;
      (this.form.questionId ? editQuestion : addQuestion)(this.form).then(
        (res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.showDialog = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 修改题目
    async handleEdit(questionId) {
      let res = await questionInfo(questionId);
      this.form = res.data;
      this.showDialog = true;
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.questionId);
    },
    handleDel(questionIds) {
      this.$confirm("确定要删除题目吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delQuestion(questionIds).then((res) => {
            this.$loading.show();
            if (res.code == 0) {
              this.getList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 重置
    handleReset() {
      this.$confirm(`确定要重置为系统默认吗?`, {
        type: "warning",
      })
        .then(() => {
          this.setFn();
        })
        .catch(() => {});
    },
    setFn() {
      this.$loading.show();
      resetList(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.getList();
          this.$message.success("测评问卷已初始化");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // // 下载模板
    // handleDownload() {
    //   window.open(
    //     `${process.env.VUE_APP_API_DOMAIN}/app/teacher/question/template`,
    //     "_blank"
    //   );
    // },
    // // 导入
    // handleImport(file) {
    //   let formData = new FormData();
    //   formData.append("file", file.raw);
    // },
  },
};
</script>

<style lang="less" scoped>
.questionnaire {
  text-align: left;
  .top-row {
    margin-bottom: 10px;
    overflow: hidden;
    ::v-deep .search-input {
      width: 300px;
      .el-input-group__append {
        background-color: teal;
        border-color: teal;
        color: #fff;
      }
    }
    .btns {
      float: right;
    }
  }
  ::v-deep .question-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>